var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '@api/base';
const buildUrl = (url) => {
    const baseURL = process.env.KEYCHAIN_API_DEV === 'true'
        ? 'http://localhost:5000'
        : 'https://api.steem-keychain.com';
    return `${baseURL}/${url}`;
};
const get = (url) => __awaiter(void 0, void 0, void 0, function* () {
    return yield BaseApi.get(buildUrl(url));
});
const post = (url, body) => __awaiter(void 0, void 0, void 0, function* () {
    return yield BaseApi.post(buildUrl(url), body);
});
export const KeychainApi = {
    get,
    post,
};
